import { render, staticRenderFns } from "./MerchantRecharge.vue?vue&type=template&id=5b660a6c&scoped=true&"
import script from "./MerchantRecharge.vue?vue&type=script&lang=js&"
export * from "./MerchantRecharge.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRecharge.vue?vue&type=style&index=0&id=5b660a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b660a6c",
  null
  
)

export default component.exports